
import { Importer, ImportAnalysis, ImportResult, ImportOptions } from '../types';
import { analyzeBackupFile, restoreBackup } from '../../services/backupService';

export const totalGestImporter: Importer = {
    id: 'glowpro-native',
    label: 'Copia de Seguridad GlowPro',
    description: 'Restaura una copia de seguridad nativa (.json o .zip) creada por esta aplicación.',
    accepts: ['.json', '.zip'],

    async canHandle(file: File): Promise<boolean> {
        // Quick check: filename or lightweight content check check could act here
        // For now, if extension matches (Registry checks extension), we say yes.
        // Deep analysis happens in analyze().
        return true;
    },

    async analyze(file: File): Promise<ImportAnalysis> {
        const result = await analyzeBackupFile(file);
        const res: any = result;
        return {
            valid: res.valid,
            type: 'GlowPro Backup',
            summary: {
                contacts: res.summary?.contacts || 0,
                invoices: res.summary?.invoices || 0,
                quotes: res.summary?.quotes || 0,
                expenses: res.summary?.expenses || 0,
                items: res.summary?.items || 0,
                templates: res.summary?.templates || 0,
                recurring: res.summary?.recurring || 0,
                payments: res.summary?.payments || 0,
                inbox: res.summary?.inbox || 0,
                emailTemplates: res.summary?.emailTemplates || 0
            },
            warnings: res.warnings,
            data: res.data
        };
    },

    async import(file: File, data: any, options?: ImportOptions): Promise<ImportResult> {
        try {
            const clearExisting = options?.clearExisting ?? false;
            const stats = await restoreBackup(data, clearExisting);

            return {
                success: true,
                message: 'Restauración completada correctamente.',
                created: stats.created,
                updated: stats.updated,
                skipped: {},
                errors: [],
                warnings: []
            };
        } catch (e) {
            return { success: false, message: (e as Error).message, errors: [(e as Error).message] };
        }
    }
};
